import { DEFAULT_MONACO_EDITOR_OPTIONS } from "../../cell/monaco/options";
import { WorkbenchViewport } from "../../workbench/state";

import { ContextWorkbenchAskThread } from "./contextWorkbenchAskThread";
import { ContextWorkbenchEditorRegions } from "./contextWorkbenchEditorRegion";
import { ContextWorkbenchEditorSidebar } from "./contextWorkbenchEditorSidebar";
import { ContextWorkbenchEditorTabGroups } from "./contextWorkbenchEditorTab";
import {
  ContextWorkbenchEntities,
  getInitialContextWorkbenchEntities,
} from "./contextWorkbenchEntity";
import { ContextWorkbenchFileId } from "./contextWorkbenchFile";
import { ContextWorkbenchHistory } from "./contextWorkbenchHistory";
import { ContextWorkbenchPublishChangeset } from "./contextWorkbenchPublishChangeset";

export type ContextWorkbenchState = {
  view: "editor" | "publish";
  entities: ContextWorkbenchEntities;
  editor: {
    tabGroups: ContextWorkbenchEditorTabGroups;
    viewport: WorkbenchViewport;
    regions: ContextWorkbenchEditorRegions;
    sidebar: ContextWorkbenchEditorSidebar;
  };
  publish: {
    view: "changes" | "ask-preview";
    changeset: ContextWorkbenchPublishChangeset;
    askPreviewThread: ContextWorkbenchAskThread | null;
    selectedFileId: ContextWorkbenchFileId | null;
  };
  history: ContextWorkbenchHistory.State;
};

// implemented as a function to protect against changes
export const getContextWorkbenchInitialState = (): ContextWorkbenchState => {
  return {
    view: "editor",
    entities: getInitialContextWorkbenchEntities(),
    editor: {
      tabGroups: [],
      viewport: { type: "empty" },
      regions: {
        left: {
          position: "left",
          display: "sidebar",
          isOpen: true,
          size: 341,
          maxSize: 600,
          minSize: 200,
        },
        bottom: {
          position: "bottom",
          display: "none",
          isOpen: false,
          size: 0,
          minSize: 0,
          maxSize: 0,
        },
        right: {
          position: "right",
          display: "none",
          isOpen: false,
          size: 0,
          minSize: 0,
          maxSize: 0,
        },
      },
      sidebar: {
        panelId: "files",
        files: {
          type: "files",
        },
        history: {
          type: "history",
          timelineSortDirection:
            ContextWorkbenchHistory.TimelineSortDirection.DESC,
        },
      },
    },
    publish: {
      view: "changes",
      changeset: {
        loading: false,
        error: undefined,
        value: undefined,
        loadId: undefined,
      },
      askPreviewThread: null,
      selectedFileId: null,
    },
    history: {
      dialog: {
        isOpen: false,
      },
      timeline: {
        selectedNodeId: null,
        sortDirection: ContextWorkbenchHistory.TimelineSortDirection.DESC,
      },
      versionPanel: {
        tabId: ContextWorkbenchHistory.VersionPanelTabId.CHANGES,
        changesFilter:
          ContextWorkbenchHistory.VersionPanelChangesFilter.CHANGED,
        fileExpanded: {},
      },
      editor: {
        options: DEFAULT_MONACO_EDITOR_OPTIONS,
      },
    },
  };
};
